import React, { Component } from 'react';
import { $ } from 'rype-bootstrap';

import ModalDecorator from 'hocs/ModalDecorator';

import LanguageSelect from '../../LanguageSelect/LanguageSelect';
import PlanComparisonList from '../../PlanComparisonList/PlanComparisonList';

import './ServicePlanModal.css';

class ServicePlanModal extends Component {
  constructor() {
    super();

    $.noConflict();
  }

  componentDidMount() {
    // the HOC ModalDecorator adds and removes this modal from the DOM.
    //
    // once the component mounts, we need to manually add call show
    // to force Bootstrap to render the modal
    //
    // the delay is present to smooth the transitions
    // while the component continues to load
    setTimeout(() => $('#service-plan-modal').modal('show'), 75);

    // set up an event listener to call this.props.closeModal
    // whenever the modal is hidden.
    // closeModal comes from ModalDecorator, and causes
    // the element to be removed from the DOM
    $('#service-plan-modal').on('hidden.bs.modal', () => {
      this.props.closeModal();
    });
  }

  close = () => {
    // Call 'hide' to reset all the Bootstrap styling
    $('#service-plan-modal').modal('hide');
  }

  render() {
    return (
      <div
        id="service-plan-modal"
        className="ServicePlanModal modal fade"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="service-plan-label"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header bg-secondary">
              <div className="modal-head text-md-center mx-md-auto">
                <h2 className="modal-title display-4" id="service-plan-label">
                  Choose Your Plan
                </h2>

                <LanguageSelect />
              </div>

              <button
                className="close align-self-start ml-2 ml-sm-0"
                type="button"
                aria-label="Close"
                onClick={this.close.bind(this)}
              >
                <span aria-hidden="true"> &times; </span>
              </button>
            </div>

            <div className="modal-body">
              <PlanComparisonList />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ModalDecorator('service-plan-modal')(ServicePlanModal);



// WEBPACK FOOTER //
// ./src/components/modals/ServicePlanModal/ServicePlanModal.js